<div class="mobilemenu" [ngClass]="{ 'mobilemenu--open': isOpen }">
  <div class="mobilemenu__backdrop" (click)="this.menuService.close(3)"></div>
  <div class="mobilemenu__body">
    <div class="px-3 flex align-items-center" style="height: 50px">
      <i
        class="fa-regular fa-square-chevron-left fa-2x me-2"
        style="cursor: pointer"
        (click)="this.menuService.close(3)"
      ></i>
      <div class="text-truncate text-center col me-5" style="color: #000">
        {{ label | titlecase }}
      </div>
    </div>

    <div class="mobilemenu__content">
      <ul>
        @for(item of thirdLevelMenuItems; track $index) {
        <li class="mb-3 flex justify-content-between">
          <div
            class="text-truncate"
            (click)="select()"
            [routerLink]="item.url"
          >
            {{ item.name | titlecase }}
          </div>
        </li>
        } @if(hasViewAllLink){
        <li class="mt-3 flex justify-content-center">
          <div (click)="select()" [routerLink]="url">
            Ver todo y {{ label | titlecase }}
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
</div>
